<template>
  <div>
    <Page :title="pageTitle" :isFullWidth="true">
      <template v-slot:action>
        <div class="Polaris-ActionMenu">
          <div class="Polaris-ActionMenu-Actions__ActionsLayout">
            <div class="Polaris-ButtonGroup Polaris-ButtonGroup--extraTight">
              <div class="Polaris-ButtonGroup__Item">
                <span class="">
                  <button
                    class="Polaris-Button"
                    type="button"
                    @click="openTemplates"
                  >
                    <span class="Polaris-Button__Content">
                      <span class="Polaris-Button__Text">Templates</span>
                    </span>
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="Polaris-Page-Header__PrimaryActionWrapper">
          <div class="Polaris-Box Polaris-Box--printHidden">
            <button
              class="Polaris-Button Polaris-Button--primary"
              type="button"
              @click="refreshCurrentPage"
              :disabled="isLoading"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Text"
                  >Refresh<span v-if="isLoading">ing</span></span
                >
              </span>
            </button>
          </div>
        </div>
      </template>
      <template v-slot:default>
        <div class="flex flex-col max-w-7xl mx-auto my-10">
          <div
            class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
          >
            <div v-if="isLoading">
              <Spinner />
            </div>
            <div class="">
              <div class="">
                <div>
                  <div class="">
                    <div class="Polaris-Labelled__LabelWrapper">
                      <div class="Polaris-Label">
                        <label
                          id="PolarisTextField1Label"
                          for="PolarisTextField1"
                          class="Polaris-Label__Text"
                          >Search By Order Id</label
                        >
                      </div>
                    </div>
                    <div class="Polaris-Connected">
                      <div
                        class="Polaris-Connected__Item Polaris-Connected__Item--primary flex"
                      >
                        <div
                          class="Polaris-TextField Polaris-TextField--hasValue flex-1 mr-2"
                        >
                          <input
                            id="PolarisTextField1"
                            v-model="searchText"
                            autocomplete="off"
                            class="Polaris-TextField__Input Polaris-TextField__Input--hasClearButton"
                            type="text"
                            aria-labelledby="PolarisTextField1Label"
                            aria-invalid="false"
                            placeholder="Enter Order Id"
                            @keydown.enter="loadPage(1)"
                          />
                          <button
                            type="button"
                            class="Polaris-TextField__ClearButton"
                            @click="searchText = ''"
                          >
                            <span
                              class="Polaris-Text--root Polaris-Text--visuallyHidden"
                              >Clear</span
                            >
                            <span
                              class="Polaris-Icon Polaris-Icon--colorBase Polaris-Icon--applyColor"
                            >
                              <span
                                class="Polaris-Text--root Polaris-Text--visuallyHidden"
                              >
                              </span>
                              <svg
                                viewBox="0 0 20 20"
                                class="Polaris-Icon__Svg"
                                focusable="false"
                                aria-hidden="true"
                              >
                                <path
                                  fill-rule="evenodd"
                                  d="M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm-2.293 4.293a1 1 0 0 0-1.414 1.414l2.293 2.293-2.293 2.293a1 1 0 1 0 1.414 1.414l2.293-2.293 2.293 2.293a1 1 0 1 0 1.414-1.414l-2.293-2.293 2.293-2.293a1 1 0 0 0-1.414-1.414l-2.293 2.293-2.293-2.293z"
                                ></path>
                              </svg>
                            </span>
                          </button>
                          <div class="Polaris-TextField__Backdrop"></div>
                        </div>
                        <button
                          class="Polaris-Button"
                          type="button"
                          @click="loadPage(1)"
                        >
                          <span class="Polaris-Button__Content">
                            <span class="Polaris-Button__Text">Search</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-col">
              <div
                class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
              >
                <ManualMessageAlert />

                <div
                  class="align-middle inline-block min-w-full shadow  sm:rounded-lg border-b border-gray-200 mb-24"
                >
                  <div class="Polaris-Card">
                    <div class="">
                      <div class="Polaris-DataTable__Navigation">
                        <button
                          class="Polaris-Button Polaris-Button--disabled Polaris-Button--plain Polaris-Button--iconOnly"
                          aria-label="Scroll table left one column"
                          aria-disabled="true"
                          type="button"
                          tabindex="-1"
                        >
                          <span class="Polaris-Button__Content">
                            <span class="Polaris-Button__Icon">
                              <span class="Polaris-Icon">
                                <span
                                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                                >
                                </span>
                                <svg
                                  viewBox="0 0 20 20"
                                  class="Polaris-Icon__Svg"
                                  focusable="false"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414l-4.293 4.293 4.293 4.293a.999.999 0 0 1-.707 1.707z"
                                  ></path>
                                </svg>
                              </span>
                            </span>
                          </span>
                        </button>
                        <button
                          class="Polaris-Button Polaris-Button--plain Polaris-Button--iconOnly"
                          aria-label="Scroll table right one column"
                          type="button"
                        >
                          <span class="Polaris-Button__Content">
                            <span class="Polaris-Button__Icon">
                              <span class="Polaris-Icon">
                                <span
                                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                                >
                                </span>
                                <svg
                                  viewBox="0 0 20 20"
                                  class="Polaris-Icon__Svg"
                                  focusable="false"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M8 16a.999.999 0 0 1-.707-1.707l4.293-4.293-4.293-4.293a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5a.997.997 0 0 1-.707.293z"
                                  ></path>
                                </svg>
                              </span>
                            </span>
                          </span>
                        </button>
                      </div>
                      <div
                        class="Polaris-DataTable Polaris-DataTable__ShowTotals overflow-auto"
                      >
                        <div class="">
                          <table class="Polaris-DataTable__Table">
                            <thead>
                              <tr class="hidden md:table-row">
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                                  scope="col"
                                >
                                  Order
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Date
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Customer Name
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Total
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Payment
                                </th>

                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Fulfillment
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Message Sent
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Tags
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                ></th>
                              </tr>
                            </thead>
                            <tbody>
                              <OrderItem
                                v-for="order in orders.docs"
                                :key="order.id"
                                :order="order"
                                :shop-origin="shopOrigin"
                                @refreshCurrentPage="refreshCurrentPage"
                                @openCustomerInfo="openCustomerInfo"
                              />
                            </tbody>
                          </table>
                        </div>

                        <Pagination :page="orders" @pageChanged="loadPage" />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="align-middle inline-block min-w-full  overflow-hidden text-center py-16"
                  v-if="!isLoading && orders.docs && orders.docs.length === 0"
                >
                  You don't have any order right now. We will be listing them
                  here as soon as order is placed.
                </div>
              </div>
            </div>
            <CustomerInfoModal
              v-if="showCustomerInfoModal"
              :phoneNumber="currentCustomerPhoneNumber"
              @close="closeCustomerInfo"
            />
          </div>
          <div class="Polaris-FooterHelp">
            <div class="Polaris-FooterHelp__Text">
              Learn more about
              <!-- -->
              <a
                target="blank"
                class="Polaris-Link"
                href="https://app.tango.us/app/workflow/f9980f94-b15c-4dac-a60a-32694259d61f"
                data-polaris-unstyled="true"
                >Manual Order Messages</a
              >
            </div>
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";

import Page from "./Page.vue";

import OrderItem from "./OrderItem";

import Pagination from "./Pagination";
import ManualMessageAlert from "./ManualMessageAlert";
import CustomerInfoModal from "./CustomerInfoModal.vue";

export default {
  name: "OrderDetails",
  data() {
    return {
      pageTitle: "Orders",
      isLoading: false,
      searchText: "",
      currentCustomerPhoneNumber: null,
      showCustomerInfoModal: false
    };
  },
  components: {
    Page,
    OrderItem,
    Pagination,
    Spinner,
    ManualMessageAlert,
    CustomerInfoModal
  },
  computed: {
    orders() {
      return this.$store.getters.getOrder;
    },
    config() {
      return this.$store.getters.getConfig;
    },
    shopOrigin() {
      const { shopOrigin } = this.$store.getters.getStore;
      return shopOrigin;
    }
  },
  created() {
    this.loadPage(1);
    this.$store.dispatch("getOrderTemplates");
    this.$store.dispatch("getConfig");
  },
  methods: {
    async loadPage(page) {
      this.isLoading = true;
      await this.$store.dispatch("getOrderList", {
        page,
        searchText: this.searchText
      });
      this.isLoading = false;
    },
    refreshCurrentPage() {
      this.searchText = "";
      const page = this.orders.page;
      this.loadPage(page);
    },
    openTemplates() {
      this.$router.push({ name: "Templates" });
    },
    openCustomerInfo(phoneNumber) {
      this.currentCustomerPhoneNumber = phoneNumber;
      this.showCustomerInfoModal = true;
    },
    closeCustomerInfo() {
      this.showCustomerInfoModal = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
